import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {HashRouter} from "react-router-dom";
import { LoadingProvider } from './components/Loading/LoadingContext';
import MyLoading from "./components/Loading/MyLoading";
import {GlobalStateProvider} from "./utils/GlobalStateContext";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <GlobalStateProvider>
  <HashRouter>
    <LoadingProvider>
    <App />
      <MyLoading></MyLoading>
    </LoadingProvider>
  </HashRouter>
    </GlobalStateProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
